import React, {Fragment, useContext} from "react"
import AppSidebarGroup from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarGroup";
import AppSidebarMenuItem from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarMenuItem";
import {getChildRouterLink} from "root/Wieldy/routePaths";
import {getPostMenuTypeForUser, PostMenus} from "root/DataFunctions/PageContentRoles";
import GlobalContext from "root/contexts/GlobalContext";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {PostMenuTitles, PostFilters} from "root/DataFunctions/Constants";

const ChildPostsSubmenu = (props ) =>
{
    const globals = useContext(GlobalContext);
    const menuType = getPostMenuTypeForUser ( globals.userType ) ;

    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    // Ensure we always have a default message filter ( From the URL or a default )
    const message_filter_type = queryParams.type === undefined ? PostFilters.NEW : queryParams.type;

    const editorPostSubmenu =() => {
        return (
            <AppSidebarGroup title='Posts' default={message_filter_type}>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.NEW )} title={PostMenuTitles.NEW} iconName='icon-important' name={PostFilters.NEW}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.DRAFT)} title={PostMenuTitles.DRAFT} iconName='icon-thumb-up' name={PostFilters.DRAFT} />
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.APPROVED )} title={PostMenuTitles.APPROVED} iconName='icon-thumb-up' name={PostFilters.APPROVED}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.DISCUSSING )} title={PostMenuTitles.DISCUSSING} iconName='icon-question-circle' name={PostFilters.DISCUSSING}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.HELD)} title={PostMenuTitles.HELD} iconName='icon-forgot-password' name={PostFilters.HELD}/>
                <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.ARCHIVED)} title={PostMenuTitles.ARCHIVED} iconName='icon-lock-screen' name={PostFilters.PENDING}/>
            </AppSidebarGroup>
        )
    }

    const contributorPostSubmenu =() => {
        return (
        <AppSidebarGroup title='Posts' default={message_filter_type}>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.NEW )} title='Submitted'iconName='icon-important' name={PostFilters.NEW}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.DRAFT)} title={PostMenuTitles.DRAFT} iconName='icon-thumb-up' name={PostFilters.DRAFT} />
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.APPROVED)} title={PostMenuTitles.APPROVED} iconName='icon-thumb-up' name={PostFilters.APPROVED} />
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.DISCUSSING )} title={PostMenuTitles.DISCUSSING} iconName='icon-question-circle' name={PostFilters.DISCUSSING}/>
            <AppSidebarMenuItem link={getChildRouterLink(props.child_uid, 'posts?type=' + PostFilters.HELD)} title={PostMenuTitles.HELD} iconName='icon-forgot-password' name={PostFilters.HELD}/>
        </AppSidebarGroup>
        )
    }

    const menuSection = () =>
    {
        const menuType = props.is_editor ? editorPostSubmenu() : contributorPostSubmenu();
        return menuType;
    }

    return (
        <Fragment>
            { menuSection ()}
        </Fragment>
    )
}

export default ChildPostsSubmenu ;